import { useMyOrderById } from "api/Client/product";
import { Spinner } from "components";
import { useEffect } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { GiSandsOfTime, GiTakeMyMoney } from "react-icons/gi";
import { MdNumbers } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
import { useNavigate } from "react-router-dom";
import ClientActionModal from "../ClientActionModal/ClientActionModal";

export default function MyOrderModal({ isOpen, toggle, orderId, url }) {
  const navigate = useNavigate();
  const {
    data: currentOrder,
    isSuccess: currentOrderIsSuccess,
    isFetching: currentOrderIsFetching,
  } = useMyOrderById(orderId);

  useEffect(() => {
    return () => url && navigate("/control-panel/my-orders", { replace: true });
  }, []);

  return (
    <ClientActionModal
      open={isOpen}
      close={toggle}
      size="small"
      title={"تفاصيل السحب"}
    >
      {currentOrderIsFetching ? (
        <div className="bg-mainLight p-5 flex justify-center items-center rounded-md shadow-md mx-auto">
          <Spinner sm />
        </div>
      ) : (
        currentOrderIsSuccess && (
          <div className="grid grid-cols-1 gap-4 my-4">
            <div className="bg-mainLight/20 grid gap-1 h-fit text-white p-6 rounded-2xl shadow-lg border border-mainLight hover:shadow-xl transition-shadow">
              <div className="flex justify-between items-center flex-row-reverse">
                {" "}
                <h2
                  className="text-xl font-bold text-white"
                  style={{ direction: "ltr" }}
                >
                  {Number(Math.abs(currentOrder.data.total)).toLocaleString()}{" "}
                  <span className="text-sm">
                    {currentOrder.data.currency /* || "S.P" */}
                  </span>{" "}
                </h2>
                {currentOrder.data.order_state === "pending" ? (
                  <div className={`text-white items-center flex gap-3`}>
                    <div className="text-xl p-1">
                      <GiSandsOfTime />
                    </div>
                    <span className="font-bold">{"انتظار"}</span>
                  </div>
                ) : currentOrder.data.order_state === "approved" ||
                  currentOrder.data.order_state === "completed" ? (
                  <div className={`text-green-500 items-center flex gap-3`}>
                    <div className="text-xl p-1">
                      <FaCheck />
                    </div>
                    <span className="font-bold">{"مكتملة"}</span>
                  </div>
                ) : currentOrder.data.order_state === "rejected" ||
                  currentOrder.data.order_state === "canceled" ? (
                  <div className={`text-red-500 items-center flex gap-3`}>
                    <div className="text-xl p-1">
                      <FaTimes />
                    </div>
                    <span className="font-bold">{"مرفوضة"}</span>
                  </div>
                ) : null}
              </div>
              <div className={`text-white items-center flex gap-3`}>
                <div className="text-xl p-1 text-white">
                  <FaMoneyBillTransfer />
                </div>
                <span className="font-bold">{"سحب مبلغ"}</span>
              </div>
              <div className={`text-white items-center flex gap-3`}>
                <div className="text-xl p-1 text-white">
                  <MdNumbers />
                </div>
                <span className="font-bold">
                  رقم الطلب: {currentOrder.data.id}
                </span>
              </div>
              <div className="text-white items-center text-sm flex gap-3">
                <div className="text-xl p-1 text-white">
                  <GiTakeMyMoney />
                </div>{" "}
                <span className="font-bold">{currentOrder.data.service}</span>
              </div>

              <div className="text-white items-center flex gap-3">
                <div className="text-xl p-1 text-white">
                  <SlCalender />
                </div>{" "}
                <span style={{ direction: "ltr" }} className="font-bold">
                  {" "}
                  {currentOrder.data.created_at}{" "}
                </span>
              </div>
            </div>

            {!isEmpty(currentOrder.data.field) && (
              <div className="bg-mainLight/20 p-6 rounded-2xl shadow-lg border border-mainLight hover:shadow-xl transition-shadow">
                <h5 className="text-center font-bold text-lg text-white mb-4">
                  معلومات الطلب
                </h5>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {Object.entries(currentOrder.data.field).map(
                    ([key, item]) => (
                      <div className="flex flex-col gap-1" key={key}>
                        <span className="text-sm font-semibold text-white ">
                          {item.name}
                        </span>
                        <span className="text-lg font-bold text-white">
                          {item.value}
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}

            {currentOrder.data.reason && (
              <div className="bg-mainLight/20 p-6 rounded-2xl shadow-lg border border-mainLight hover:shadow-xl transition-shadow">
                <h5 className="text-center font-bold text-lg text-white mb-4">
                  {currentOrder.data.order_state === "rejected" ||
                  currentOrder.data.order_state === "canceled"
                    ? "سبب الرفض"
                    : "الملاحظات"}
                </h5>
                <h5
                  className="text-white font-bold text-center_"
                  dangerouslySetInnerHTML={{
                    __html: currentOrder.data.reason?.replace(/\n/g, "<br />"),
                  }}
                ></h5>
              </div>
            )}
          </div>
        )
      )}
    </ClientActionModal>
  );
}

function isEmpty(field) {
  // التحقق إذا كان غير معرّف أو يساوي null
  if (field === undefined || field === null) return true;

  // التحقق إذا كان كائنًا فارغًا
  if (typeof field === "object") {
    return Object.keys(field).length === 0;
  }

  // التحقق إذا كان مصفوفة فارغة
  if (Array.isArray(field)) {
    return field.length === 0;
  }

  // إذا كان نوعًا آخر
  return false;
}
